import { AuthState } from '@okta/okta-auth-js';
import axios from 'axios';
import BaseService from './baseService';

export default class BlobService extends BaseService {
    constructor() {
        super();
    }

    public async getTutorialVideoUrl(authState: AuthState | null): Promise<string> {
        try {
            const response = await axios.get<{ url: string }>(`${this.REACT_APP_API_BASE_URL}/video_tutorial/url`, this.getHeaders(authState));
            const url = response.data.url as string;
            return url;
        } catch (error) {
            console.error("Error fetching tutorial video URL:", error);
            throw error;
        }
    }

}